// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QuCQ","col":"styles_col__1r0Fh"};